const { createStorefrontApiClient } = require('@shopify/storefront-api-client')

const storeDomain = process.env.GATSBY_SHOPIFY_STORE_URL
const publicAccessToken = process.env.GATSBY_STOREFRONT_ACCESS_TOKEN

const storefrontClient = createStorefrontApiClient({
  storeDomain,
  publicAccessToken,
  apiVersion: '2026-01',
})

module.exports = { storefrontClient }
